import React from 'react';
import {
  VerticalSp,
  HorizontalSp,
  RowColum,
  HSLine,
  ContentsArea,
  ModalTitle,
  ModalContents,
  ModalNorBtn,
} from '../../../components/Common';
import { isMobile } from 'react-device-detect';
import Ratio from 'react-ratio';
import { InputBase } from '@material-ui/core';
import { Modal, Fade } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import images from '../../../assets';
import { TitleBlock, InfoLabel, SaveButton } from '../../../components/mypage/Mypage';
import { InputGroup, InputPad, inputStyle } from '../../../components/auth/login';
import { Essential } from '../../../components/auth/editaccount';
import store from '../../../store';
import Store from 'store';
import apiClient from '../../../_utils/axios';
import { getModalWidh }  from '../../../_utils/modalWidh';
import { withTranslation } from 'react-i18next';
import { SpecRadio } from '../../../components/mypage/GoodsList';
import { marketingApi } from '../../../marketing-api';

class SignOut extends React.Component {
  state = {
    password: '',
    reason: '',
    radioNumber: 1,
    showmodal: false,
  };

  onCloseModal = () => {
    this.setState({ showmodal: false });
  };

  onClickRadioButtun = (value) =>{
    const radioNumber = value;
    if(radioNumber === 1){
      this.setState({ radioNumber: 1 });
    }else if(radioNumber === 2){
      this.setState({ radioNumber: 2 });
    }else if(radioNumber === 3){
      this.setState({ radioNumber: 3 });
    }else if(radioNumber === 4){
      this.setState({ radioNumber: 4 });
    }else if(radioNumber === 5){
      this.setState({ radioNumber: 5 });
    }else if(radioNumber === 6){
      this.setState({ radioNumber: 6 });
    }else if(radioNumber === 7){
      this.setState({ radioNumber: 7 });
    }
  }

  onSignOut = async () => {
    const password = this.state.password,
      reason = this.state.reason,
      radioNumber = this.state.radioNumber;

    const { t } = this.props;

    if (password.length === 0 && store.getState().register_type === 'email') {
      let err = '비밀번호를 입력해주세요.';
      if (Store.get('lang') !== 'kr') {
        err = 'Please enter the password';
      }
      this.onCloseModal();
      return alert(err);
    } else if (radioNumber === 5 && reason.length === 0) {
      let err = '탈퇴이유를 입력해주세요.';
      if (Store.get('lang') !== 'kr') {
        err = 'Please enter the reason for withdrawal';
      }
      this.onCloseModal();
      return alert(err);
    }


    let selectRadioReason = t('sign_out_one');
    if(radioNumber === 1){
      selectRadioReason = t('sign_out_one');
    }else if(radioNumber === 2){
      selectRadioReason = t('sign_out_two');
    }else if(radioNumber === 3){
      selectRadioReason = t('sign_out_three');
    }else if(radioNumber === 4){
      selectRadioReason = t('sign_out_four');
    }else if(radioNumber === 5){
      selectRadioReason = t('sign_out_five');
    }else if(radioNumber === 6){
      selectRadioReason = t('sign_out_six');
    }else if(radioNumber === 7){
      selectRadioReason = reason
    }


    const res = await apiClient.post('/web/delete/info', {
      password,
      reason: selectRadioReason,
    });

    if (res) {
      if (Store.get('lang') === 'kr') {
        alert(res.data.message_ko);
      } else {
        alert(res.data.message_en);
      }
      // Store.remove('accessToken');
      // Store.remove('userData');
      this.props.history.push('/');
      Store.clearAll();
    }
  };

  onShowModal = () => {
    marketingApi.useDeActiveAccountEffect();
    this.setState({ showmodal: true });
  };

  render() {
    const { t } = this.props;
    const { password, reason, showmodal, radioNumber } = this.state;
    return (
      <div style={{ flex: 1, width: '100%' }}>
        <TitleBlock title={t('deactivate_your_account')} />
        <HSLine bgcolor="#dddddd" height={1} />
        <RowColum>
          <ContentsArea style={{ maxWidth: 500 }}>
            <VerticalSp sp={'2.7vw'} style={{ maxHeight: 50, minHeight: 25 }} />
            {store.getState().register_type === 'email' && (
              <>
                <InfoLabel>{t('password')}</InfoLabel>
                <VerticalSp sp={'0.6vw'} style={{ maxHeight: 10, minHeight: 5 }} />
                <InputGroup style={{ borderBottomColor: '#a0a0a0' }}>
                  <InputPad>
                    <InputBase
                      type="password"
                      placeholder={t('password_detail')}
                      value={password}
                      onChange={(event) => {
                        this.setState({ password: event.target.value });
                      }}
                      inputProps={{ style: inputStyle }}
                      style={{ width: '100%', borderBottom: '1px solid #999999' }}
                    />
                  </InputPad>
                </InputGroup>
                <VerticalSp sp={'1.8vw'} style={{ maxHeight: 40, minHeight: 20 }} />
              </>
            )}
            {Store.get('lang') === 'kr'? 
            <><InfoLabel>{t('sign_out_greetings_hello_one_a')}</InfoLabel>
            <InfoLabel>{t('sign_out_greetings_hello_one_b')}</InfoLabel>
            <InfoLabel>{t('sign_out_greetings_hello_two_a')}</InfoLabel>
            <InfoLabel>{t('sign_out_greetings_hello_two_b')}</InfoLabel></>
            :
            <><InfoLabel>{t('sign_out_greetings_hello_one_a')}{t('sign_out_greetings_hello_one_b')}</InfoLabel>
            <InfoLabel>{t('sign_out_greetings_hello_two_a')}{t('sign_out_greetings_hello_two_b')}</InfoLabel></>
            }
            
            <VerticalSp sp={'1.6vw'} style={{ maxHeight: 30, minHeight: 5 }} />
   

            <div className="radio-wrapper">
                 <SpecRadio
                    onClick={() =>
                      this.onClickRadioButtun(1)
                    }
                  >
                    <img
                      alt=""
                      src={radioNumber === 1 ? images.icon_license_act : images.icon_license_nor}
                      style={{ marginRight: 10 }}
                    />
                    {t('sign_out_one')}
                  </SpecRadio>
                  <VerticalSp sp={'0.6vw'} style={{ maxHeight: 10, minHeight: 5 }} />
           
                 <SpecRadio
                    onClick={() =>
                      this.onClickRadioButtun(2)
                    }
                  >
                    <img
                      alt=""
                      src={radioNumber === 2 ? images.icon_license_act : images.icon_license_nor}
                      style={{ marginRight: 10 }}
                    />
                    {t('sign_out_two')}
                  </SpecRadio>
                  <VerticalSp sp={'0.6vw'} style={{ maxHeight: 10, minHeight: 5 }} />
                  <SpecRadio
                    onClick={() =>
                      this.onClickRadioButtun(3)
                    }
                  >
                    <img
                      alt=""
                      src={radioNumber === 3 ? images.icon_license_act : images.icon_license_nor}
                      style={{ marginRight: 10 }}
                    />
                    {t('sign_out_three')}
                  </SpecRadio>
                  <VerticalSp sp={'0.6vw'} style={{ maxHeight: 10, minHeight: 5 }} />
                  <SpecRadio
                    onClick={() =>
                      this.onClickRadioButtun(4)
                    }
                  >
                    <img
                      alt=""
                      src={radioNumber === 4 ? images.icon_license_act : images.icon_license_nor}
                      style={{ marginRight: 10 }}
                    />
                    {t('sign_out_four')}
                  </SpecRadio>
                  <VerticalSp sp={'0.6vw'} style={{ maxHeight: 10, minHeight: 5 }} />
                  <SpecRadio
                    onClick={() =>
                      this.onClickRadioButtun(5)
                    }
                  >
                    <img
                      alt=""
                      src={radioNumber === 5 ? images.icon_license_act : images.icon_license_nor}
                      style={{ marginRight: 10 }}
                    />
                    {t('sign_out_five')}
                  </SpecRadio>
                  <VerticalSp sp={'0.6vw'} style={{ maxHeight: 10, minHeight: 5 }} />
                  <SpecRadio
                    onClick={() =>
                      this.onClickRadioButtun(6)
                    }
                  >
                    <img
                      alt=""
                      src={radioNumber === 6 ? images.icon_license_act : images.icon_license_nor}
                      style={{ marginRight: 10 }}
                    />
                    {t('sign_out_six')}
                  </SpecRadio>
                  <VerticalSp sp={'0.6vw'} style={{ maxHeight: 10, minHeight: 5 }} />
                  <SpecRadio
                    onClick={() =>
                      this.onClickRadioButtun(7)
                    }
                  >
                    <img
                      alt=""
                      src={radioNumber === 7 ? images.icon_license_act : images.icon_license_nor}
                      style={{ marginRight: 10 }}
                    />
                    {t('sign_out_seven')}
                  </SpecRadio>
                  <VerticalSp sp={'1.2vw'} style={{ maxHeight: 40, minHeight: 10 }} />
                  {radioNumber===7 && <TextField
                    placeholder={t('sign_out_placeholder')}
                    multiline
                    rows={6}
                    value={reason}
                    onChange={(event) => {
                      this.setState({ reason: event.target.value });
                    }}
                    variant="outlined"
                    InputProps={{ style: { ...inputStyle } }}
                    style={{ width: '100%' }}
                  />}
            </div>
            <VerticalSp sp={'1.8vw'} style={{ maxHeight: 40, minHeight: 20 }} />
            

            <div
              style={{
                fontFamily: 'NSCJKrR',
                fontSize: 16,
                textAlign: 'center',
                wordBreak: 'keep-all',
              }}
            >
            {
              Store.get('lang') === 'kr' ? 
                  <InfoLabel>
                    {t('sign_out_greetings_bye_a')}
                    {t('sign_out_greetings_bye_b')}
                  </InfoLabel>
                :
                <>
                  <InfoLabel>
                  {t('sign_out_greetings_bye_a')}
                  </InfoLabel>
                  <InfoLabel>
                 {t('sign_out_greetings_bye_b')}
                  </InfoLabel>
                </>
            }
            </div>
            <VerticalSp sp={'1.8vw'} style={{ maxHeight: 40, minHeight: 20 }} />
            <div
              style={{
                fontFamily: 'NSCJKrR',
                fontSize: 16,
                color: '#e30000',
                textAlign: 'center',
                wordBreak: 'keep-all',
              }}
            >
              <Essential />
              {t('deactivate_caution')}
            </div>
            <VerticalSp sp={'1.8vw'} style={{ maxHeight: 40, minHeight: 20 }} />
            <SaveButton onClick={this.onShowModal}>{t('deactivate_account')}</SaveButton>
            <VerticalSp sp={40} />
          </ContentsArea>
        </RowColum>
        <Modal
          style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999 }}
          open={showmodal}
          onClose={this.onCloseModal}
        >
          <Fade in={showmodal}>
            <ModalContents style={{ width: getModalWidh() }} onClose={this.onCloseModal}>
              <ModalTitle>{t('deactivate_your_account')}</ModalTitle>
              <div
                style={{
                  display: 'flex',
                  borderTop: '1px solid #eeeeee',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  textAlign: 'center',
                  paddingTop: 10,
                }}
              >
                <VerticalSp sp={'1.4vw'} style={{ maxHeight: 26, minHeight: 16 }} />
                <Ratio
                  ratio={1}
                  style={{
                    backgroundImage: `url(${images.icon_normal_avatar})`,
                    width: 64,
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    borderRadius: 100,
                  }}
                />
                <VerticalSp sp={'1vw'} style={{ maxHeight: 16, minHeight: 8 }} />
                <div style={{ fontFamily: 'NSCJKrB', color: 'black', fontSize: 24, wordBreak: 'break-all' }}>
                  {store.getState().email}
                </div>
                <VerticalSp sp={'1.4vw'} style={{ maxHeight: 26, minHeight: 16 }} />
                {Store.get('lang') === 'kr' ? (
                  <>
                    <div style={{ fontFamily: 'NSCJKrM', color: 'black', fontSize: 20, wordBreak: 'keep-all' }}>
                      회원 탈퇴하시겠습니까?
                    </div>
                    <div style={{ fontFamily: 'NSCJKrR', color: 'black', fontSize: 20, wordBreak: 'keep-all' }}>
                      회원탈퇴하시면 모든 데이터가 삭제됩니다.
                    </div>
                  </>
                ) : (
                  <>
                    <div style={{ fontFamily: 'NSCJKrM', color: 'black', fontSize: 20, wordBreak: 'keep-all' }}>
                      We're sorry to see you go. Before you leave..
                    </div>
                    <div style={{ fontFamily: 'NSCJKrR', color: 'black', fontSize: 20, wordBreak: 'keep-all' }}>
                      Deactivating your account is final. You will be removed from all comunication and you will not be
                      able to recover your account.
                    </div>
                    <div style={{ fontFamily: 'NSCJKrM', color: 'black', fontSize: 20, wordBreak: 'keep-all' }}>
                      Some information may still be visible to others, such as your name if you have purchased their
                      designs.
                    </div>
                  </>
                )}
              </div>
              <VerticalSp sp={'3vw'} style={{ maxHeight: 54, minHeight: 24 }} />
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <ModalNorBtn onClick={this.onCloseModal} style={{ backgroundColor: '#cccccc' }}>
                  {t('cancel')}
                </ModalNorBtn>
                <HorizontalSp sp={10} />
                <ModalNorBtn onClick={this.onSignOut} style={{ backgroundColor: '#ff8a06' }}>
                  {t('confirm')}
                </ModalNorBtn>
              </div>
            </ModalContents>
          </Fade>
        </Modal>
      </div>
    );
  }
}
export default withTranslation()(SignOut);
